// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleFilledSvg from "@ant-design/icons-svg/es/asn/TrademarkCircleFilled";
import AntdIcon from '../components/AntdIcon';

var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleFilledSvg
  }));
};

TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
export default React.forwardRef(TrademarkCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TrademarkCircleFilled.js
// module id = 1947
// module chunks = 0